import axios from 'axios'
import { useAuth } from '../store/auth'

/**
 * Cliente do coletor.
 *
 * Caminho relativo, nunca URL absoluta: em produção o Nginx serve o build
 * estático e encaminha `/registry` para o mesmo host. Uma URL absoluta aqui
 * significaria um build por ambiente.
 */
export const api = axios.create({ baseURL: '/' })

api.interceptors.request.use((config) => {
  const token = useAuth.getState().token
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  (r) => r,
  (erro) => {
    // 401 significa token vencido ou e-mail fora de REGISTRY_ADMINS. Os dois
    // levam à mesma tela; distinguir só ajudaria quem está tentando adivinhar.
    if (erro.response?.status === 401) useAuth.getState().sair()
    return Promise.reject(erro)
  },
)

/** A mensagem que a API mandou, ou a do axios. Nunca "[object Object]". */
export function mensagemDoErro(erro) {
  const d = erro?.response?.data
  if (!d) return erro?.message ?? 'Falha desconhecida.'
  if (typeof d === 'string') return d
  if (Array.isArray(d.problemas)) {
    return d.problemas.map((p) => `${p.onde}: ${p.problema}`).join('\n')
  }
  return d.message ?? d.error ?? erro.message
}

export const registro = {
  console: () => api.get('/registry/console').then((r) => r.data),
  portfolio: (dias = 30) => api.get('/registry/portfolio', { params: { dias } }).then((r) => r.data),
  drift: (dias = 30) => api.get('/registry/drift', { params: { dias } }).then((r) => r.data),
  abrirRascunho: () => api.post('/registry/draft').then((r) => r.data),
  salvarRascunho: (content) => api.put('/registry/draft', content).then((r) => r.data),
  publicar: (reason) => api.post('/registry/publish', { reason }).then((r) => r.data),
  voltarPara: (version) => api.post('/registry/rollback', { version }).then((r) => r.data),
  edicao: (version) => api.get(`/registry/editions/${version}`).then((r) => r.data),
  catalogo: () => api.get('/registry/catalog').then((r) => r.data),
  motores: () => api.get('/registry/engines').then((r) => r.data),
  comparacao: (feature, dias = 30) =>
    api.get('/registry/comparison', { params: { feature, dias } }).then((r) => r.data),
  ensaiar: (candidatos, casos) =>
    api.post('/registry/comparison/run', { candidatos, casos }).then((r) => r.data),
}
